let workerScriptTrustedTypesPolicy: Pick<TrustedTypePolicy, "name" | "createScriptURL"> | undefined;
if (self.trustedTypes) {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function createPolicy called at module scope is not allowed. This may cause unwanted side effects. */
    workerScriptTrustedTypesPolicy = self.trustedTypes.createPolicy("workerScriptTrustedTypesPolicy", {
        createScriptURL: (url: string) => url,
    });
}

export { workerScriptTrustedTypesPolicy };
